import { useCallback, useEffect, useState } from "react";
import {
  ChartTooltipState,
  VisualizationData,
} from "../components/OutputsWrapper/components/VisualizationBlock/types";

type Props = VisualizationData;

const useChartYaxis = (chart: Props) => {
  const [tooltip, setTooltip] = useState<ChartTooltipState>({
    visible: false,
    value: "",
    x: 0,
    y: 0,
  });
  const [maxTickWidth, setMaxTickWidth] = useState(0);
  const [calc, setCalc] = useState({ exponent: 0, multiplier: 0 });

  const calculatePowerOf10Multiplier = (maxYaxis: number) => {
    if (maxYaxis === 0) return { exponent: 0, multiplier: 1 }; // Avoid log(0)

    // Only apply scientific notation if number ≥ 1,000,000
    if (maxYaxis < 1_000_000) {
      return { exponent: 0, multiplier: 1 };
    }

    const power = Math.floor(Math.log10(maxYaxis));
    const exponent = power >= 3 ? Math.floor(power / 3) * 3 : 0; // Round to nearest 0, 3, 6, 9
    return {
      exponent,
      multiplier: Math.pow(10, exponent), // e.g., 10³ = 1000
    };
  };

  const tooltipHandler = (tooltip: ChartTooltipState) => {
    setTooltip(tooltip);
  };

  // calculate the scientific notation needed for this specific chart
  useEffect(() => {
    const values = calculatePowerOf10Multiplier(chart.range.y_range[1]);
    setCalc(values);
  }, [chart]);

  // Track widest tick label
  const handleTickWidth = useCallback((width: number) => {
    setMaxTickWidth((prev) => Math.max(prev, width));
  }, []);

  return {
    tooltip,
    tooltipHandler,
    maxTickWidth,
    calc,
    handleTickWidth,
  };
};

export default useChartYaxis;
